export default __webpack_public_path__ + "static/BGC Logo Lockup-848dd33e3c1e696ce9c2cab0a069ec00.jpg";